import {
  SWITCH_FETCH_REQUEST,
  SWITCH_FETCH_REQUEST_SUCCESS,
  SWITCH_FETCH_REQUEST_FAILURE,
  SWITCH_ADD_REQUEST,
  SWITCH_ADD_REQUEST_SUCCESS,
  SWITCH_ADD_REQUEST_FAILURE,
  SWITCH_UPDATE_REQUEST,
  SWITCH_UPDATE_REQUEST_SUCCESS,
  SWITCH_UPDATE_REQUEST_FAILURE,
  SWITCH_CLEAN_REQUEST,
} from '../constants/actionTypes';

const INITIAL_STATE = {
  payload: [],
  loading: false,
  errors: {},
  pagination: {
    current: 0,
    pageSize: 0,
    total: 0,
    totalPage: 0,
  },
};

/**
 * A reducer takes two arguments, the current state and an action.
 */
const switchesReducer = (state, action) => {
  state = state || INITIAL_STATE;

  switch (action.type) {
    case SWITCH_FETCH_REQUEST:
    case SWITCH_ADD_REQUEST:
    case SWITCH_UPDATE_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case SWITCH_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        payload: action.data,
        loading: false,
        errors: {},
        pagination: {
          current: action.data.currentPage,
          pageSize: action.data.pageSize,
          total: action.data.totalRecord,
          totalPage: action.data.totalPage,
          showSizeChanger: true,
        },
      });

    case SWITCH_ADD_REQUEST_SUCCESS:
    case SWITCH_UPDATE_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        payload: action.data,
        loading: false,
        errors: {},
      });

    case SWITCH_FETCH_REQUEST_FAILURE:
    case SWITCH_ADD_REQUEST_FAILURE:
    case SWITCH_UPDATE_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    case SWITCH_CLEAN_REQUEST:
      return Object.assign({}, state, {
        payload: [],
        loading: false,
        errors: {},
        pagination: {
          current: 0,
          pageSize: 0,
          total: 0,
          totalPage: 0,
        },
      });

    default:
      return state;
  }
};

export default switchesReducer;
